import { useEffect } from 'react';
import axios from 'axios';

const useFetchDraws = (promoId, setDrawsWeek, setDrawsMonth, setDrawsFinal, setSorteio) => {
  useEffect(() => {
    if (!promoId) {
      return
    }

    axios.get(`${process.env.REACT_APP_API_URL}/sorteios?promo_id=${promoId}`, {
      headers: {
        'Authorization': `Bearer ${localStorage.getItem('accessToken')}`
      },
    })
      .then((response) => {
        setDrawsWeek(response.data.semanal);
        setDrawsMonth(response.data.mensal);
        setDrawsFinal(response.data.final);
        const allDraws = [...response.data.semanal, ...response.data.mensal, ...response.data.final];
        let allHappenedDraws = allDraws.filter((draw) => draw.status !== 'nao_realizado');
        allHappenedDraws.sort((a, b) => new Date(a.data).getTime() - new Date(b.data).getTime());
        const currentDate = new Date().getTime();
        const nearestDraw = allHappenedDraws.reduce((prev, curr) => {
          if (!prev) {
            return curr;
          }

          const prevDate = new Date(prev.data).getTime();
          const currDate = new Date(curr.data).getTime();

          const prevDiff = Math.abs(currentDate - prevDate);
          const currDiff = Math.abs(currentDate - currDate);

          return prevDiff < currDiff ? prev : curr;
        }, null);

        if (!nearestDraw) {
          return;
        }

        setSorteio(nearestDraw);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [promoId, setDrawsFinal, setDrawsMonth, setDrawsWeek, setSorteio]);

};

export default useFetchDraws;
